export enum CheckoutModalStatusEnum {
  Description = 'Prosimy o chwilę cierpliwości...',
  PreparingPayment = 'Przygotowywanie\npłatności',
  ProcessingPayment = 'Wystawianie\nwniosku',
  Step = 'KROK',
  TransmittingData = 'Przesyłanie\nTwoich danych',
}
